<div *ngIf="mode === 'reserva'">
<div class="reservation-modal">
    <!-- Modal Header -->
    <div class="modal-header">
        <h3 style="margin: 0; flex: 1; display: flex; align-items: center; gap: 0.5rem; font-weight: 600;"> 
            Detalles de la Reserva # {{reservation_id}}
        </h3>
        <div class="status-badge">
          Estado: <strong style="color: orange;">Pendiente</strong>
        </div>
        <button mat-icon-button (click)="onCancel()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Modal Content -->
    <mat-dialog-content class="modal-content">
        <div class="reservation-info">
            <!-- Information Section -->
            <div class="info-section">
                <div class="section-title">
                    <mat-icon>description</mat-icon>
                    <h3>Información de la Reserva</h3>
                </div>
                <div class="info-list">
                    <div class="info-row">
                        <span class="label">Cliente:</span>
                        <span class="value">{{ client?.given_name }} {{ client?.family_name }}</span>
                    </div>
                    <div class="info-row">
                        <span class="label">Alojamiento:</span>
                        <span class="value">{{ room_type }} - {{ accommodation_name }}</span>
                    </div>
                    <div class="info-row">
                        <span class="label">Fechas:</span>
                        <span class="value">{{ check_in }} - {{ check_out }}</span>
                    </div>
                    <div class="info-row">
                        <span class="label">Huéspedes:</span>
                        <span class="value"></span>
                    </div>
                    <div class="info-row">
                        <span class="label">Total a Pagar:</span>
                        <span class="value">{{ total_value | currency }}</span>
                    </div>
                    <div class="payment-button-row">
                        <button mat-flat-button color="primary" class="btn-new"
                         (click)="openPayment()">
                    <mat-icon>payment</mat-icon>
                    <span class="hidden sm:inline">Registrar Pago</span>
                     </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="reservation-info" style="padding-top: 2%;">
            <!-- Information Section -->
            <div class="info-section">
                <div class="section-title section-title-with-button">
                    <div class="section-title-content">
                        <mat-icon>group</mat-icon>
                        <h3>Huéspedes Acompañantes</h3>
                    </div>
                    <button mat-raised-button color="primary" class="btn-secondary"
                             (click)="openPayment()">
                        <span><mat-icon class="icon-small">person_add</mat-icon>Agregar Huésped</span>
                    </button>
                </div>
                <div class="payment-button-row">
                    <button mat-raised-button color="primary" class="btn-new"
                             (click)="openPayment()">
                        
                        <span><mat-icon class="icon-small">person_add</mat-icon>Agregar Huésped</span>
                    </button>
                </div>
            </div>
        </div>
    </mat-dialog-content>

    <!-- Modal Footer with Buttons -->
    <div class="modal-footer">
        <button mat-raised-button class="btn-action" (click)="onCheckIn()">
            <mat-icon>check_circle</mat-icon>
            Check-in
        </button>
        <button mat-raised-button class="btn-action" (click)="onAddConsumption()">
            <mat-icon>add_shopping_cart</mat-icon>
            Agregar Consumo
        </button>
        <button mat-raised-button class="btn-action" (click)="onCheckOut()">
            <mat-icon>logout</mat-icon>
            Check-out
        </button>
    </div>
</div>
</div>


<div *ngIf="mode === 'pago'">
<div class="reservation-modal">
    <!-- Modal Header -->
    <div class="modal-header">
        <h2 style="margin: 0; flex: 1; display: flex; align-items: center; gap: 0.5rem; font-weight: 600; color: #114981;"> 
            Registrar Pago
        </h2>
        
        <button mat-icon-button (click)="onCancel()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Modal Content -->
    <mat-dialog-content class="modal-content">
        <div class="reservation-info">
            <!-- Information Section -->
            <div class="info-section">
            
                <div class="info-list">
                   
                    <div >
                        <span class="value">Monto a Pagar:</span>

                    </div>
                    <div style="background-color: rgb(245, 240, 240);height:40px;border-radius: 10px;">
                
                        <div style="padding-left:1%;padding-top:10px;padding-bottom:10px;"><span class="label" >{{ total_value | currency }}</span></div>
                    </div>

                     <div >
                        <span class="value">Metodo de Pago:</span> 
                    </div>
                    <div>
        
                      <div class="dropdown">
                        <button class="dropdown-btn" (click)="toggleDropdown()">
                           <span>
                         {{ selectedItem || 'Seleccionar método de pago' }}
                         </span>
                          <span class="arrow" [class.rotated]="isDropdownOpen">▼</span>
                        </button>
                        
                        <div class="dropdown-content" *ngIf="isDropdownOpen">
                          <div 
                            *ngFor="let item of items; let i = index" 
                            class="dropdown-item"
                            (click)="selectItem(item)">
                            {{ item }}
                          </div>
                        </div>
                      </div>
                      
                        
                    </div>
                    <div class="info-row">
                        
                    </div>
                    <div>
                        <input type="text" placeholder="Referencia de pago (opcional)" 
                               class="payment-reference-input" 
                               [(ngModel)]="paymentReference">
                    </div>
                    <div class="comprobante">

                        <div style="padding: 12px; border-radius: 10px; margin-bottom: 12px;"><span class="value">Cargar Comprobante</span></div>
                        <div>
                             <button mat-raised-button color="primary" class="btn-secondary"
                             (click)="fileInput.click()">
                        <span class="upload-link">Seleccionar archivo</span>
                        <input #fileInput type="file" id="file-input" accept="image/*,application/pdf" (change)="onFilesSelected($event)"
                      style="display: none;">
                    </button>
                        </div>

                        
                    </div>
                </div>
            </div>
        </div>

      
    </mat-dialog-content>

    <!-- Modal Footer with Buttons -->
    <div class="modal-footer">

        <button mat-raised-button color="primary" class="btn-cancel"
                             (click)="cancelpayment()">
                        <span>Cancelar</span>
                    </button>

        <button mat-flat-button color="primary" class="btn-confirm"
                         (click)="openPayment()">
                    <span class="hidden sm:inline">Confirmar Pago</span>
                     </button>
    </div>
</div>
</div>